import React, { useMemo, useEffect, useRef } from 'react';

export default function QuickReplyDropdown({
  quickReplies,
  filter,
  onSelect,
  onClose,
}) {
  const dropdownRef = useRef(null);

  // Filtrar atalhos pelo que o usuário digitou
  const filtered = useMemo(() => {
    if (!filter || filter === '/') {
      return quickReplies;
    }
    const searchTerm = filter.toLowerCase();
    return quickReplies.filter(reply => {
      const matchShortcut = reply.shortcut.toLowerCase().startsWith(searchTerm);
      const matchTitle = reply.title
        .toLowerCase()
        .includes(searchTerm.replace('/', ''));
      return matchShortcut || matchTitle;
    });
  }, [quickReplies, filter]);

  // Fechar ao clicar fora
  useEffect(() => {
    const handleClickOutside = e => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  if (filtered.length === 0) return null;

  return (
    <div
      ref={dropdownRef}
      className="hide-scrollbar"
      style={{
        position: 'absolute',
        bottom: '100%',
        left: '12px',
        right: '12px',
        background: '#fff',
        border: '0.5px solid #dee2e6',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        maxHeight: '240px',
        overflowY: 'auto',
        overflowX: 'hidden',
        zIndex: 10,
        marginBottom: '4px',
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
      }}
    >
      <div
        style={{
          padding: '8px 12px',
          borderBottom: '0.5px solid #dee2e6',
          fontSize: '11px',
          fontWeight: 600,
          color: '#888780',
        }}
      >
        Atalhos rápidos
      </div>
      {filtered.map(reply => (
        <div
          key={reply.shortcut}
          role="button"
          tabIndex={0}
          onClick={() => onSelect(reply)}
          style={{
            padding: '8px 12px',
            cursor: 'pointer',
            borderBottom: '0.5px solid #f2f2f0',
            transition: 'background 0.1s',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = '#f8f8f6';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = 'transparent';
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <span
              style={{
                fontSize: '12px',
                fontWeight: 600,
                color: '#0F6E56',
              }}
            >
              {reply.shortcut}
            </span>
            {reply.category && (
              <span
                style={{
                  fontSize: '10px',
                  color: '#888780',
                  background: '#f2f2f0',
                  padding: '1px 6px',
                  borderRadius: '8px',
                }}
              >
                {reply.category}
              </span>
            )}
          </div>
          <div
            style={{
              fontSize: '12px',
              color: '#5F5E5A',
              marginTop: '2px',
            }}
          >
            {reply.title}
          </div>
        </div>
      ))}
    </div>
  );
}
